import React, { useState, useEffect, useRef } from "react";
import HeaderRecruteur from "../../header/headerRec";
import './ProfilRecruteur.css';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ProfileForm from "../../commun/ProfileForm";
import CustomAlert from "../../commun/CustomAlert";
import Footer from '../../commun/Footer';
import { Avatar, Button } from "@mui/material";
import LoadingPopup from "../../commun/LoadingPopup";

const ProfilRecruteur = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  let recruteurName = localStorage.getItem("recruteurName");

  const [formData, setFormData] = useState({
    utilisateur: {
      lastName: "",
      firstName: "",
      email: "",
      phone: "",
      photo: ""
    },
    linkedin: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  const fetchRecruteurData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      if (!token || !userId) return navigate("/");

      const response = await axios.get(`${API_BASE}/api/recruteur/profil/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setFormData((prev) => ({
        ...prev,
        utilisateur: {
          ...prev.utilisateur,
          ...response.data.utilisateur,
        },
        linkedin: response.data.linkedin || "",
      }));

      setIsLoading(false);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRecruteurData();
  }, []);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleChange = (e, path) => {
    let value = e.target.value;
    if (path === "utilisateur.phone") value = value.replace(/\D/g, "");

    const updated = { ...formData };
    if (path === 'newPassword' || path === 'confirmPassword') {
      updated[path] = value;
    } else {
      const keys = path.split('.');
      keys.reduce((acc, key, idx) => {
        if (idx === keys.length - 1) acc[key] = value;
        else acc[key] = acc[key] || {};
        return acc[key];
      }, updated);
    }
    setFormData(updated);
  };

  const handleSave = async () => {
    const linkedin = formData.linkedin.trim();
    if (linkedin && !linkedin.startsWith("https://")) {
      setAlertMessage("Le lien LinkedIn doit commencer par 'https://'");
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");
      if (!token || !userId) return navigate("/");

      await axios.patch(`${API_BASE}/api/recruteur/edit/${userId}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const updatedName = `${formData.utilisateur.firstName} ${formData.utilisateur.lastName}`;
      localStorage.setItem("recruteurName", updatedName);
      recruteurName = updatedName;

      setAlertMessage("Informations mises à jour !");
      setAlertSeverity("success");
      setAlertOpen(true);
      setIsEditing(false);
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      setAlertMessage("Erreur lors de la mise à jour.");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const token = localStorage.getItem("authToken");
    const form = new FormData();
    form.append("file", file);

    try {
      const userId = formData.utilisateur._id;
      const res = await axios.post(`${API_BASE}/api/entreprise/upload-interlocuteur-photo/${userId}`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setFormData((prev) => ({
        ...prev,
        utilisateur: {
          ...prev.utilisateur,
          photo: res.data.photo
        }
      }));
      localStorage.setItem("recruteurAvatar", res.data.photo);
      window.dispatchEvent(new Event("storage")); 
      setAlertMessage("Photo mise à jour !");
      setAlertSeverity("success");
      setAlertOpen(true);
    } catch (err) {
      setAlertMessage("Erreur lors de l'upload de la photo.");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  const avatarSrc = formData.utilisateur.photo
    ? `${API_BASE}${formData.utilisateur.photo}?${Date.now()}`
    : undefined;

  const fields = [
    { label: "Email", name: "utilisateur.email", type: "email" },
    { label: "Téléphone", name: "utilisateur.phone", type: "tel" },
    { label: "Nom", name: "utilisateur.lastName" },
    { label: "Prénom", name: "utilisateur.firstName" },
    { label: "LinkedIn", name: "linkedin" }
  ];

  if (isLoading) return 
      <LoadingPopup
      open={!isLoading}
      message="Chargement..."
    />;

    const handlePasswordChange = async (newPassword) => {
      handleSave();
    };
    
  return (
    <div className="recruteur-page">
      <HeaderRecruteur recruteurName={recruteurName} />

      <div className="profile-header">
        <div className="profile-avatar-wrapper">
          <Avatar
            src={avatarSrc}
            alt="Photo recruteur"
            className="profile-avatar logo-image"
          >
            {`${(formData.utilisateur.firstName || '').charAt(0)}${(formData.utilisateur.lastName || '').charAt(0)}`}
          </Avatar>
          <div className="profile-name">
            {`${formData.utilisateur.firstName || ''} ${formData.utilisateur.lastName || ''}`.trim()}
          </div>
          <Button onClick={() => fileInputRef.current.click()} className="upload-btn">
            Changer la photo
          </Button>
          <input
            type="file"
            accept="image/*"
            hidden
            ref={fileInputRef}
            onChange={handlePhotoUpload}
          />
        </div>
      </div>

      <section className="profile-container">
        <ProfileForm
          title="Profil Recruteur"
          formData={formData}
          setFormData={setFormData}
          fields={fields}
          isEditing={isEditing}
          onSave={handleSave}
          onToggleEdit={handleEditToggle}
          showSaveButton={isEditing}
          isInterlocuteurTab
          handleChange={handleChange}
          onChangePassword={handlePasswordChange}
        />
      </section>
      <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
      <Footer />

    </div>
  );
};

export default ProfilRecruteur;
